module.exports = __webpack_public_path__ + "img/popup_seoul_songpagu_healthcare_notification.01933bce.png";